/**
 *  This is our Axios configuration and start of the connection.
 *  It checks local storage to see if there is a JWT token present for future API calls.
 *  Our backend applications use JWT authentication and most calls will require this to be set.
 *
 *  We can also set which headers are required. This will feed into our other api calls which are
 *  separated into different files for easy managment and readiibility
 */

import axios from 'axios';
import Store from '@/store/store';
import Router from '@/router';
import AppService from '@/services/app';

axios.defaults.withCredentials = true;

export default () => {
 
  const thisAxios = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });

  thisAxios.interceptors.request.use(config => {
    if (config.url !== '/auth/login') {
      config.headers['Authorization'] = Store.getters['auth/token'];
    }
    return Promise.resolve(config);
  }, (error) => {
    return Promise.reject(error);
  });

  // check for any 401 - Unauthorized responses and kick to login url
  thisAxios.interceptors.response.use((response) => {
    return response;
  }, (error) => {


    if ((error.response && error.response.status && 401 === error.response.status) ||
      (error.message && error.message === 'Request failed with status code 401')) {  

      // if this is a brand new window / session, the first thing we will do is call AuthService.checkAuth()
      // in the router beforeEnter. If this is the FIRST call, 
      // we don't want to show them the session timeout error, 
      // we just want to redirect them to login
      const originalRequest = error.config;      
      if (originalRequest.url !== '/auth/me') {
        AppService.errorHandler(Store.state.app.messages.sessionTimeout);
      }
      Store.dispatch('auth/setLoggedInState', {
        loggedIn: false,
      });
      console.log(`api.ts - 29 - ${new Date().toISOString().split('.')[0].replace('T', ' ')}`, 'Got a 401, kicking back to Login'); 

      // TODO may need to do some work here to figure out if we go back to / or /iframe ?
      Router.push('/');
      return Promise.reject(); // dont send error back because we want the sessionTimeout error to show

    } else {
      // removed log support debug here as it is creating a loop
      return Promise.reject(error);
    }
  });

  return thisAxios;
};
